export enum ContactLabels {
  PRIMARY = 0,
  SECONDARY,
  BILLING,
}

export enum ContactType {
  EMAIL = 0,
  PHONE,
}

export class Contact {
  organization_id = "";

  user_id = "";

  contact_type = ContactType.EMAIL;

  label = ContactLabels.PRIMARY;

  value = "";

  id = "";
}
